import { Helmet } from 'react-helmet-async';
import { useQuery } from 'react-query';
import styled from 'styled-components';

import { API_URL } from 'api/API';
import getAllObsDataApi from 'api/now/getAllObsDataApi';

import { ObsId } from 'libs/types';

import CamGrid from 'components/now/CamGrid';
import Header from 'components/now/Header';
import ObsInfoTable from 'components/now/ObsInfoTable';

const OBS_ORDER_LIST = ['1', '2', '3', '4', '5', '0'] as ObsId[];

const Background = styled.div`
  min-height: 100vh;
  background-color: #474849;
`;

const Wrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 40px;
  max-width: 1880px;
  margin: 0 auto;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
`;

const Main = () => {
  const { data } = useQuery([API_URL.NOW.GET_ALL_OBS_DATA], getAllObsDataApi, {
    refetchInterval: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <ObsInfoTable obsInfo={data?.obs_info} obsOrderList={OBS_ORDER_LIST} latestData={data?.latest_data} />
      <CamGrid
        obsInfo={data?.obs_info}
        obsOrderList={OBS_ORDER_LIST}
        latestSkycam={data?.latest_skycam}
        latestScam={data?.latest_scam}
      />
    </div>
  );
};

const OWLNetNow = () => {
  return (
    <>
      <Helmet title="OWL-Net NOW" />
      <Background>
        <Wrapper>
          <Header />
          <Main />
        </Wrapper>
      </Background>
    </>
  );
};

export default OWLNetNow;
